import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import api, { saveAdminToken } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await api.adminLogin(email.trim(), password);
      saveAdminToken(r.token);
      nav("/admin", { replace: true });
    } catch (er) {
      setErr(er?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(180deg, rgba(12,39,71,0.92), rgba(12,39,71,0.72)), url('https://images.unsplash.com/photo-1616391182219-e080b4d1043a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwZGVudGFsJTIwY2xpbmljJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg2Mzc1MzIyfDA&ixlib=rb-4.1.0&q=85') center/cover no-repeat",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 20,
          padding: 32,
          width: "min(440px, 100%)",
          boxShadow: "0 24px 60px rgba(12, 39, 71, 0.28)",
          border: "1px solid #e5eaf1",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 22 }}>
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 999,
              background: "linear-gradient(160deg, #C49A45, #e2b95b)",
              color: "#0C2747",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "'Playfair Display', serif",
              fontWeight: 700,
              fontSize: 22,
            }}
          >
            S
          </div>
          <div>
            <div className="font-display" style={{ fontSize: 22, fontWeight: 700, color: "#0C2747", lineHeight: 1 }}>
              Srinidhi
            </div>
            <div style={{ fontSize: 12, color: "#64748B", marginTop: 2 }}>Admin dashboard</div>
          </div>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 600, margin: "0 0 6px", color: "#0C2747" }}>Sign in</h1>
        <p style={{ margin: 0, fontSize: 13, color: "#64748B", marginBottom: 22 }}>
          Only the clinic team can access conversations and appointment requests.
        </p>

        <form onSubmit={submit}>
          <div className="sd-form-row">
            <label className="sd-label">Email</label>
            <input
              data-testid="admin-email"
              type="email"
              className="sd-form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@srinidhidental.com"
              required
            />
          </div>

          <div className="sd-form-row">
            <label className="sd-label">Password</label>
            <input
              data-testid="admin-password"
              type="password"
              className="sd-form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {err && (
            <div data-testid="admin-login-error" className="sd-form-error" style={{ marginBottom: 10 }}>
              {err}
            </div>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            className="sd-btn-primary"
            style={{ width: "100%", padding: "12px 14px", fontSize: 14, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8 }}
            disabled={loading}
          >
            <LogIn size={16} /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 20, color: "#64748B", fontSize: 12 }}>
          <ShieldCheck size={14} color="#1b53a6" />
          Sessions expire after 12 hours.
        </div>
      </div>
    </div>
  );
}
